import "./Menu.module.css";
import Header from "@/reusable_sections/Header";
import FromOurKitchen from "./sections/FromOurKitchen";
import SeasonalSipsBites from "./sections/SeasonalSipsBites";
import TheCoffeeMatchaBar from "./sections/TheCoffeeMatchaBar";
import Syrups from "./sections/Syrups";
import Footer from "@/reusable_sections/Footer";
export default function MenuPage() {
  return <div>
      <Header />
      <FromOurKitchen />
      <Syrups />
      <SeasonalSipsBites />
      <TheCoffeeMatchaBar />
      <Footer />
    </div>;
}